<template>
  <div id="page-top" class="formulario py-5">
    <div class="container">
      <div class="col text-center py-5">
        <img :src="logo" height="40px" alt />
      </div>
    </div>
    <div class="my-5">
      <div class="message-card container p-3" role="form">
        <h3>Su email ha sido confirmado</h3>
        <span>En unos momentos va a recibir un email con su POBOX</span>
        <div class="volver-inicio">
          <button class="btn btn-primary" @click="goToHome()">Volver al inicio</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import logo from "../assets/navbar-logo.svg";
import { confirmEmail } from "../service/api";
import { HOME_URL } from "../config";

export default {
  data() {
    return { logo };
  },
  methods: {
    goToHome() {
      window.location.href = HOME_URL;
    },
  },
  mounted() {
    confirmEmail(this.$route.query.token).then((response) => {
      if (response.status > 200 && response.status < 300) {
        console.log("EXitoso");
      } else {
        console.log("Fallo");
      }
    });
  },
};
</script>